var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationLink',{attrs:{"link-params":_vm.linkParams.dashboard}},[_c('img',{attrs:{"id":"logo-footer","src":_vm.logoURL.footer,"width":"136","alt":"footer logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }